import { Skeleton } from './types';

const skeletonTheme: Skeleton = {
	colors: {
		color: '',
		modes: {
			light: {
				color: 'neutral.100'
			},
			dark: {
				color: 'neutral.700'
			}
		}
	}
};

export default skeletonTheme;
